import React from "react";
import { Step } from "../types";

interface StepNavigationProps {
  currentStep: Step;
  onStepClick: (step: Step) => void;
  stepLabels: Record<Step, string>;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  onStepClick,
  stepLabels,
}) => {
  return (
    <>
      {/* ── Desktop steg-navigation ── */}
      <ol className="wizardsteps">
        {([1, 2, 3, 4, 5] as Step[]).map((s) => (
          <li
            key={s}
            className="wizardstep__container wizardstep__container--activity"
          >
            <div className="wizardstep">
              <button
                type="button"
                onClick={() => onStepClick(s)}
                disabled={currentStep < s}
                className={
                  currentStep === s
                    ? "activity__step-button"
                    : currentStep > s
                      ? "activity__step-button--prevactive"
                      : "activity__step-button--inactive"
                }
                aria-label={`Gå till steg ${s}: ${stepLabels[s]}`}
                aria-current={currentStep === s ? "step" : undefined}
              >
                {s}
              </button>

              {s < 5 && <i className="wizardstep__arrow" />}
            </div>

            <strong>{stepLabels[s]}</strong>
          </li>
        ))}
      </ol>

      {/* ── Mobil steg-indikator ── */}
      <div className="wizardsteps--mobile wizardsteps--mobile__activity g-col-12">
        <h2>
          Steg {currentStep} av 5: {stepLabels[currentStep]}
        </h2>
        {currentStep !== 5 && (
          <p>Nästa: {stepLabels[(currentStep + 1) as Step]}</p>
        )}
      </div>

      {/* ── Steg-progress visuell ── */}
      <div className="wizardprogress g-col-12">
        <ul className="g-col-12">
          {([1, 2, 3, 4, 5] as Step[]).map((s) => (
            <li
              key={s}
              className={
                currentStep === s
                  ? "wizardstep wizardstep__activity g-col-2 active"
                  : currentStep > s
                    ? "wizardstep wizardstep__activity g-col-2 prevactive"
                    : "wizardstep wizardstep__activity g-col-2"
              }
            >
              <span></span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
